// extracted by mini-css-extract-plugin
export default {"description":"toastMessage_description__NdhZP"};